/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ISitePickerViewProps } from '@msdyn365-commerce-modules/site-picker/src/modules/site-picker/./site-picker';

export default (props: ISitePickerViewProps) => {
    return <>{_renderSitePicker(props)}</>;
};

const _renderMobileView = (props: ISitePickerViewProps): React.ReactNode => {
    const { SitePickerMobileContainer } = props;
    return (
        <Node {...SitePickerMobileContainer} onClick={props.renderSiteOptions}>
            <div>
                {props.SitePickerMenuListItemArray?.map((item, index) => {
                    return <div key={index}>{item}</div>;
                })}
            </div>
        </Node>
    );
};

const _renderSitePicker = (props: ISitePickerViewProps): React.ReactNode => {
    const { SitePicker } = props;
    return (
        <Module {...SitePicker}>
            {_renderMobileView(props)}
        </Module>
    );
};
